import React from "react";
import { TextField } from "@mui/material";
import MDTypography from "components/MDTypography";
import PropTypes from "prop-types";

function MDTextField({
  error,
  helperText,
  formik,
  name,
  placeholder,
  displayName,
  required,
  inputType,
  value,
  onChange,
  maxLength,
}) {
  const handleChange = (event) => {
    let updatedValue = event.target.value;

    if (inputType === "onlyNumbers") updatedValue = updatedValue.replace(/[^0-9]/g, "");
    else if (inputType === "onlyString") updatedValue = updatedValue.replace(/[^a-zA-Z 0-9,]/g, "");

    if (maxLength && updatedValue.length > maxLength) return;

    if (formik?.setFieldValue) {
      formik.setFieldValue(name, updatedValue);
    } else if (onChange) {
      onChange(updatedValue);
    }
  };
  const currentValue = formik?.values[name] || value || "";
  return (
    <>
      <MDTypography style={{ fontSize: "16px" }} color="dark">
        {displayName} <span style={{ color: "red" }}>{required ? "*" : ""}</span>
      </MDTypography>
      <TextField
        name={name}
        error={error || (formik ? Boolean(formik.touched[name] && formik.errors[name]) : false)}
        fullWidth
        value={formik?.values[name] || value}
        onChange={handleChange}
        helperText={helperText || (formik && formik.touched[name] ? formik.errors[name] : "")}
        placeholder={placeholder}
        inputProps={maxLength ? { maxLength } : {}}
        slotProps={{
          input: {
            sx: {
              height: "50px",
            },
          },
        }}
      />
      {maxLength && (
        <MDTypography
          variant="caption"
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            color: "#666",
            fontSize: "0.75rem",
            mt: 0.5,
          }}
        >
          {currentValue.length} / {maxLength}
        </MDTypography>
      )}
    </>
  );
}

MDTextField.propTypes = {
  error: PropTypes.bool,
  helperText: PropTypes.string,
  formik: PropTypes.object,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  displayName: PropTypes.string.isRequired,
  required: PropTypes.bool,
  inputType: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  maxLength: PropTypes.number,
};

export default MDTextField;
